import { render, staticRenderFns } from "./ServiceComment.vue?vue&type=template&id=94f405d8&scoped=true&"
import script from "./ServiceComment.vue?vue&type=script&lang=ts&"
export * from "./ServiceComment.vue?vue&type=script&lang=ts&"
import style0 from "./ServiceComment.vue?vue&type=style&index=0&id=94f405d8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94f405d8",
  null
  
)

export default component.exports